<form class="card" [formGroup]="ticketForm" (ngSubmit)="onSubmit()" [nbSpinner]="loading" autocomplete="off"
      nbSpinnerStatus="danger"
      nbSpinnerSize="large"
      nbSpinnerMessage="">

  <h2>{{ 'teams.ticket.title' | translate }}</h2>

  <div class="form-group">
    <div class="form-label">{{ 'teams.ticket.category' | translate }}</div>
    <div class="form-value">
      <nb-select fullWidth="fullWidth" id="category_id" name="category_id" formControlName="category_id">
        @for (category of ticketsCategories(); track category.category_id) {
          <nb-option [value]="category.category_id">{{category.name}}</nb-option>
        }
      </nb-select>
    </div>
  </div>

  <div class="form-group">
    <div class="form-label">{{ 'teams.ticket.email' | translate }}</div>
    <div class="form-value">
      <input id="email" nbInput type="text" formControlName="email">
    </div>
  </div>

  <div class="form-group">
    <div class="form-label">{{ 'teams.ticket.subject' | translate }}</div>
    <div class="form-value">
      <input id="title" nbInput type="text" formControlName="title">
    </div>
  </div>

  <div class="form-group">
    <div class="form-label">{{ 'teams.ticket.description' | translate }}</div>
    <div class="form-value">
      <textarea nbInput id="description" name="description" formControlName="description"></textarea>
    </div>
  </div>

  <div class="form-group">
    <div class="form-label">{{ 'teams.ticket.consent' | translate }} *</div>
    <div class="form-value">
      <input id="consent" type="checkbox" formControlName="consent" required>
    </div>
  </div>

  <button nbButton fullWidth size="medium" type="submit" [disabled]="!ticketForm.valid">{{ 'common.submit' | translate }}</button>

</form>
